<template>

    <div class="page_content module_course" aria-label="student report page">

        <course-header :course-id="course.uuid" class="header_course_dashboard" v-if="!userId"></course-header>

        <div class="row page-content student_my_report">

            <div class="col-11 dasboard-left-section report-Page">

                <div class="col-12 report-section">

                    <div class="heading ace_sec_hd">
                        <span style="float: left;">Performance</span>
                        <span v-if="userId">
                          <ol class="breadcrumb">
                            <li v-for="(item, i) in breadcrumbItems" :key="i" @click="handleBreadcrumbClick(item)" class="breadcrumb-item" :class="{active: item.active}">
                              <span :style="{cursor: item.active ? 'default' : 'pointer', color: item.active ? '' : '#157099'}">{{item.text}}</span>
                            </li>
                          </ol>
                        </span>
                        <span v-else>
                          <b-breadcrumb :items="breadcrumbItems"/>
                        </span>
                    </div>

                    <div class="page-content-inner">

                        <b-row class="dashboard-row">
                          <b-col cols="3 graph-section report-graph text-center">
                              <div class="activity-graph-container ace_sec" aria-label="distribution">
                                <div class="graph-section">
                                    <activity-bar-graph :activities="distributions" :yAxisLabel="'# of students'" class="graph-area graph-min-height ace_sec_txt"></activity-bar-graph>
                                    <div class="label text-center ace_sec_txt">Distribution - {{ performance }}%</div>
                                </div>
                              </div>
                          </b-col>
                          <b-col cols="3 graph-section report-graph text-center left-space">
                            <div class="activity-graph-container ace_sec" aria-label="score">
                                <div class="graph-section">
                                    <activity-bar-graph :activities="scores" class="graph-area ace_sec_txt"></activity-bar-graph>
                                    <div class="graph-text ace_sec_txt">Comparison</div>
                                    <div class="label text-center ace_sec_txt">Scores</div>
                                </div>
                            </div>
                          </b-col>
                          <b-col cols="3 graph-section report-graph text-center left-space">
                            <div class="activity-graph-container ace_sec" aria-label="time taken">
                                <div class="graph-section">
                                    <activity-bar-graph :activities="assessmentTimes" class="graph-area ace_sec_txt"></activity-bar-graph>
                                    <div class="graph-text ace_sec_txt">{{ assessmentTimeTakenComparisonLabel }}</div>
                                    <div class="label text-center ace_sec_txt">Time Taken</div>
                                </div>
                            </div>
                          </b-col>
                        </b-row>

                        <b-row class="col-12 heading" style="margin-top: 40px;">
                            <div class="col-10 ace_sec_txt">
                                {{ childrenSectionLabel }}
                            </div>
                            <div class="col-2" v-if="loadScoreTimeProgressGear">
                                <score-time-progress
                                    @clicked="showHideScoreTimeProgressRow"
                                    :title="'Show Rows'"
                                    :style="{visibility: (isShowLearnosityReport) ? 'hidden' : 'visible'}"
                                    :is-remove-progess-checkbox="(summaries.length > 1 && (summaries[0].competencyType === 'MC'))">
                                </score-time-progress>
                            </div>
                        </b-row>

                        <b-row class="container dashboard-row" v-if="isShowLearnosityReport">
                            <b-row class="col-12 ace_sec_txt">
                                <activity-outcome :entity-id="entityId" :course-id="course.uuid" :user-id="userId"></activity-outcome>
                            </b-row>
                        </b-row>

                        <b-row class="competency-details-row mt-2" v-else>
                            <template v-if="childrenSummary.length > 0">
                                <b-row class="col-12 competency-details-inner" v-for="(summaries, i) in chunkedChildrenSummary">
                                    <div class="columns row-title-block">
                                        <div class="column text-center">
                                            <div class="header">
                                                <div class="title" style="display: block !important;">Name</div>
                                                <div class="score-value"></div>
                                            </div>
                                            <div class="value score-column">
                                                <span class="score-box" style="color: #737373; width: 104px;">Class Average</span>
                                            </div>
                                            <div class="value score-column">
                                                <span class="score-box" style="color: #737373;">Score</span>
                                            </div>
                                            <div class="value time-column">
                                                <span class="score-box" style="color: #737373;">KC Time</span>
                                            </div>
                                            <div class="value resource-time-column">
                                                <span class="score-box" style="color: #737373; width: 111px;">Resource Time</span>
                                            </div>
                                            <div class="value progress-column">
                                                <span class="score-box" style="color: #737373;">Progress</span>
                                            </div>
                                        </div>
                                    </div>
                                    <template v-for="(summary, j) in summaries">
                                        <div :class="(i === 0 && j === 0) ? 'columns course-name-block' : 'columns'">
                                            <template v-if="(i === 0 && j === 0)">
                                                <div class="column text-center">
                                                    <div class="header">
                                                        <div class="title" style="display: block !important;">{{ summary.titleForStudent }}</div>
                                                    </div>
                                                    <div class="value score-column">
                                                        <span class="score-box" :class="getScoreBackgroundColor(summary.averageScore)">
                                                            <span v-if="summary.averageScore !== 'N/A'">{{ summary.averageScore }}%</span>
                                                            <span v-else>N/A</span>
                                                        </span>
                                                    </div>
                                                    <div class="value score-column">
                                                        <span class="score-box" :class="getScoreBackgroundColor(summary.performance)">
                                                            <span v-if="summary.performance !== null">{{ summary.performance.toFixed(2) }}%</span>
                                                            <span
                                                              v-if="summary.overriddenTime"
                                                              @click="openOverrideDetailModal(summary)"
                                                              class="score_modify_indicator"
                                                              :title="$t('overridenByAdvisorTitle')"
                                                              v-b-tooltip.hover>
                                                            </span>
                                                            <span v-if="!summary.performance">N/A</span>
                                                        </span>

                                                    </div>
                                                    <div class="value time-column">
                                                        <span class="score-box" style="background: #8f8f8f;">
                                                            <template v-if="summary.competencyType === 'RESOURCE'">
                                                                N/A
                                                            </template>
                                                            <template v-else>
                                                                {{ calculateAndShowTimeTaken(summary.assessmentTimeTaken) }}
                                                            </template>
                                                        </span>
                                                    </div>
                                                    <div class="value resource-time-column">
                                                        <span class="score-box" style="background: #8f8f8f;">
                                                            <template v-if="summary.competencyType === 'ASSESSMENT'">
                                                                N/A
                                                            </template>
                                                            <template v-else>
                                                                {{ calculateAndShowTimeTaken(summary.resourceTimeTaken) }}
                                                            </template>
                                                        </span>
                                                    </div>
                                                    <div class="value progress-column">
                                                        <template v-if="((summary.competencyType !== 'ASSESSMENT') && (summary.competencyType !== 'RESOURCE'))">
                                                            <competency-summary-progress-bar :summary="summary" :class="'competency_progress'"></competency-summary-progress-bar>
                                                        </template>
                                                    </div>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <template v-if="((summary.competencyType === 'RESOURCE') || ((summary.competencyType === 'ASSESSMENT') && (summary.status === 1)))">
                                                    <div class="column text-center">
                                                        <div class="header">
                                                            <span class="title">{{ summary.titleForStudent }}</span>
                                                        </div>
                                                        <div class="value score-column">
                                                            <span class="score-box" :class="getScoreBackgroundColor(summary.averageScore)">
                                                                <span v-if="summary.averageScore !== 'N/A'">{{ summary.averageScore }}%</span>
                                                                <span v-else>N/A</span>
                                                            </span>
                                                        </div>
                                                        <div class="value score-column">
                                                            <span class="score-box" :class="getScoreBackgroundColor(summary.performance)">
                                                                <span v-if="summary.performance !== null">{{ summary.performance.toFixed(2) }}%</span>
                                                                <span v-else>N/A</span>
                                                            </span>
                                                        </div>
                                                        <div class="value time-column">
                                                            <span class="score-box" style="background: #8f8f8f;">
                                                                <template v-if="summary.competencyType === 'RESOURCE'">
                                                                    N/A
                                                                </template>
                                                                <template v-else>
                                                                    {{ calculateAndShowTimeTaken(summary.assessmentTimeTaken) }}
                                                                </template>
                                                            </span>
                                                        </div>
                                                        <div class="value resource-time-column">
                                                            <span class="score-box" style="background: #8f8f8f;">
                                                                <template v-if="summary.competencyType === 'ASSESSMENT'">
                                                                    N/A
                                                                </template>
                                                                <template v-else>
                                                                    {{ calculateAndShowTimeTaken(summary.resourceTimeTaken) }}
                                                                </template>
                                                            </span>
                                                        </div>
														                            <div class="value progress-column">
                                                            <template v-if="((summary.competencyType !== 'ASSESSMENT') && (summary.competencyType !== 'RESOURCE'))">
                                                                <competency-summary-progress-bar :summary="summary" :class="'competency_progress'"></competency-summary-progress-bar>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <router-link :to="{ name: 'myReport', params: { uuid: course.uuid, entityId: summary.entityId, competencyId: summary.competencyId, title: summary.titleForStudent } }" @click.native.capture="handleRouteClick($event, summary)">
                                                        <div class="column text-center">
                                                            <div class="header">
                                                                <span class="title">{{ summary.titleForStudent }}</span>
                                                            </div>
                                                            <div class="value score-column">
                                                                <span class="score-box" :class="getScoreBackgroundColor(summary.averageScore)">
                                                                    <span v-if="summary.averageScore !== 'N/A'">{{ summary.averageScore }}%</span>
                                                                    <span v-else>N/A</span>
                                                                </span>
                                                            </div>
                                                            <div class="value score-column">
                                                                <span class="score-box" :class="getScoreBackgroundColor(summary.performance)">
                                                                    <span v-if="summary.performance !== null">{{ summary.performance.toFixed(2) }}%</span>
                                                                    <span v-else>N/A</span>
                                                                </span>
                                                            </div>
                                                            <div class="value time-column">
                                                                <span class="score-box" style="background: #8f8f8f;">
                                                                    <template v-if="summary.competencyType === 'RESOURCE'">
                                                                        N/A
                                                                    </template>
                                                                    <template v-else>
                                                                        {{ calculateAndShowTimeTaken(summary.assessmentTimeTaken) }}
                                                                    </template>
                                                                </span>
                                                            </div>
                                                            <div class="value resource-time-column">
                                                                <span class="score-box" style="background: #8f8f8f;">
                                                                    <template v-if="summary.competencyType === 'ASSESSMENT'">
                                                                        N/A
                                                                    </template>
                                                                    <template v-else>
                                                                        {{ calculateAndShowTimeTaken(summary.resourceTimeTaken) }}
                                                                    </template>
                                                                </span>
                                                            </div>
                                                            <div class="value progress-column">
                                                                <template v-if="((summary.competencyType !== 'ASSESSMENT') && (summary.competencyType !== 'RESOURCE'))">
                                                                    <competency-summary-progress-bar :summary="summary" :class="'competency_progress'"></competency-summary-progress-bar>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </router-link>
                                                </template>
                                            </template>
                                        </div>
                                    </template>
                                </b-row>
                            </template>
                        </b-row>

                    </div>


                </div>
            </div>

        </div>
<!-- Override Modal -->
        <div class="modal_popup_container course_unlock_modal">
          <b-modal ref="learnerCourseOverrideModal" class="description_modal" size="md" id="course-report-popup" hide-footer>
            <div slot="modal-header" class="header-section">
              <div class="head_txt" style="margin-top: 1px;">Edited Overall Score and Progress</div>
              <div class="btn_container">
                <button type="button" class="btn_close" @click="closeLearnerCourseOverrideModal" data-dismiss="modal" aria-label="Close">
                  <span class="ic-close"></span>
                </button>
              </div>
            </div>

            <div class="row txt_row">
              <div class="col-6">
                Course :
              </div>
              <div class="col-6 fld_val">
                <div v-html="course.title"></div>
              </div>
            </div>
              <div class="row txt_row mt-3">
                <div class="col-6 ">
                  Actual Overall Score :
                </div>
                <div class="col-6 fld_input" v-if="overrideSummary">
                  <span v-if="overrideSummary.overriddenTime" class="exp_info">{{overrideSummary.prePerformance?overrideSummary.prePerformance:0}}%</span>
                  <span v-else class="exp_info">{{overrideSummary.performance}}%</span>
                </div>
              </div>
              <div class="row txt_row mt-3">
                <div class="col-6 ">
                  Edited Overall Score :
                </div>
                <div class="col-6 fld_input" v-if="overrideSummary">
                  <span class="exp_info">{{overrideSummary.performance}}%</span>
                </div>
              </div>

              <div class="row txt_row mt-3">
                <div class="col-6 ">
                  Actual Overall Progress :
                </div>
                <div class="col-6 fld_input" v-if="overrideSummary">
                <div class="progress-bar-label">
                  {{overrideSummary.preChildrenCompleteCount}} of {{overrideSummary.childrenCount}}
                </div>
                <b-progress :max="overrideSummary.childrenCount">
                  <b-progress-bar :value="overrideSummary.preChildrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
                </b-progress>
                </div>
              </div>
              <div class="row txt_row mt-3" v-if="overrideSummary && overrideSummary.overriddenTime>0">
                <div class="col-6 ">
                  Edited Overall Progress :
                </div>
                <div class="col-6 fld_input" >
                <div class="progress-bar-label">
                  {{overrideSummary.childrenCompleteCount}} of {{overrideSummary.childrenCount}}
                </div>
                <b-progress :max="overrideSummary.childrenCount">
                  <b-progress-bar :value="overrideSummary.childrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
                </b-progress>
                </div>
              </div>
              <div class="row txt_row mt-3" v-if="overrideSummary && overrideSummary.overriddenTime">
                <div class="col-12 ">
                  Edited By {{overrideSummary.overriddenBy}} at  {{millisToDate(overrideSummary.overriddenTime)}}
                </div>
              </div>

            <div class="row mt-4">
              <div class="col-12 btn_container" style="text-align: right;">
                <b-button @click="closeLearnerCourseOverrideModal">
                  {{ $tf('ok') }}
                </b-button>
              </div>
            </div>
          </b-modal>
        </div>
<!-- Override Modal -->

    </div>

</template>

<script>
import { DateTime } from 'luxon'
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'
import CourseNav from './CourseNav'
import CourseHeader from './CourseHeader'
import ActivityBarGraph from './ActivityBarGraph'
import ActivityOutcome from '../../assessment/components/ActivityOutcome'
import ScoreTimeProgress from './ScoreTimeProgress'
import CompetencySummaryProgressBar from './CompetencySummaryProgressBar'

export default {
  name: 'myReport',
  props: ['uuid', 'entityId', 'competencyId', 'title', 'userId'],
  components: {
    CourseNav,
    CourseHeader,
    ActivityBarGraph,
    ActivityOutcome,
    ScoreTimeProgress,
    CompetencySummaryProgressBar
  },

  data: () => {
    return {
      breadcrumbItems: [],
      isShowLearnosityReport: false,
      childrenSectionLabel: 'Course divided into Competencies - Detailed View',
      label: {CLO: 'Course divided into Competencies - Detailed View', MC: 'Competency divided into Micro Competencies - Detailed View', ASSESSMENT: 'Micro Competency divided into Knowledge Checks - Detailed View'},
      assessmentTimeTakenComparisonLabel: '',
      selectedColumns: ['score'],
      summaries: [],
      loadScoreTimeProgressGear: false,
      overrideSummary : null
    }
  },

  watch: {
    entityId () {
      sessionStorage.clear()
      if (this.uuid === this.entityId) {
        this.breadcrumbItems = []
      }
      this.isShowLearnosityReport = false
      this.loadClassSummaryWithChildrenSummary()
    }
  },

  mounted () {
    this.loadCourse()
  },

  updated () {
    this.setBreadcrumbWidth()
  },

  methods: {
    ...mapActions([
      'loadCourseDetail',
      'loadFullClassSummary',
      'loadClassSummaryWithPeer',
      'loadChildrenSummary',
      'loadLogDashboardActivity'
    ]),

    setBreadcrumbWidth () {
      if ((this.breadcrumbItems.length) === 1) {
        $('.breadcrumb').addClass('first-level')
        $('.breadcrumb').removeClass('second-level third-level fourth-level fifth-level')
      } else if ((this.breadcrumbItems.length) === 2) {
        $('.breadcrumb').addClass('second-level')
        $('.breadcrumb').removeClass('first-level third-level fourth-level fifth-level')
      } else if ((this.breadcrumbItems.length) === 3) {
        $('.breadcrumb').addClass('third-level')
        $('.breadcrumb').removeClass('second-level first-level fourth-level fifth-level')
      } else if ((this.breadcrumbItems.length) === 4) {
        $('.breadcrumb').addClass('fourth-level')
        $('.breadcrumb').removeClass('second-level first-level third-level fifth-level')
      } else if ((this.breadcrumbItems.length) === 5) {
        $('.breadcrumb').addClass('fifth-level')
        $('.breadcrumb').removeClass('second-level first-level third-level fourth-level')
      }
    },
    openOverrideDetailModal (summary) {
      this.overrideSummary = summary
      this.$refs.learnerCourseOverrideModal.show()
    },
    closeLearnerCourseOverrideModal () {
      this.$refs.learnerCourseOverrideModal.hide()
    },
    millisToDate (millis) {
      return DateTime.fromMillis(millis).toFormat('MM/dd/yyyy')
    },

    loadCourse () {
      this.loadLogDashboardActivity({action: 'clickReport', page: 'courseHome', link: '', entityUuid: this.uuid})
      this.breadcrumbItems = []
      this.loadCourseDetail(this.uuid).then(res => {
        if (res) {
          this.loadFullClassSummary({courseId: this.uuid, loadDataFromServer: true}).then(response => {
            if (this.uuid !== this.entityId) {
              this.breadcrumbItems = JSON.parse(sessionStorage.getItem('myReportBreadcrumbItems'))
            }
            sessionStorage.clear()
            this.loadClassSummaryWithChildrenSummary()
          })
        }
      })
    },

    loadClassSummaryWithChildrenSummary () {
      var to = {name: 'myReport', params: {uuid: this.uuid, entityId: this.entityId, competencyId: this.competencyId}}
      this.loadClassSummaryWithPeer({entityId: this.entityId, userId: this.userId}).then(res => {
        if (res) {
          if (res.competencyType === 'ASSESSMENT') {
            this.childrenSectionLabel = 'Knowledge Check Activity Report'
            this.isShowLearnosityReport = true
          } else {
            const competencyId = (res.competencyId) ? res.competencyId : this.competencyId
            let data = {
              userId: this.userId,
              courseId: this.uuid,
              competencyId: competencyId
            }
            this.loadChildrenSummary(data).then(response => {
              setTimeout(() => {
                this.showHideRow()
              }, 250)
              if (response && response.length > 1) {
                var competencyType = response[1].competencyType
                if (competencyType === 'RESOURCE' || competencyType === 'ASSESSMENT') {
                  competencyType = 'ASSESSMENT'
                }
                this.childrenSectionLabel = this.label[competencyType]
              }
            })
          }
        }
        if (this.uuid === this.entityId) {
          this.breadcrumbItems.push({text: this.classSummaryWithPeer.titleForStudent, to: to, active: true})
        } else {
          if (this.title) {
            let index = _.findIndex(this.breadcrumbItems, (item) => {
              let matched = (this.title === item.text)
              if (matched) {
                item.active = true
              } else {
                item.active = false
              }
              return matched
            })
            if (index !== -1) {
              this.breadcrumbItems.splice(index + 1)
            } else {
              this.breadcrumbItems.push({text: this.title, to: to, active: true})
            }
          } else {
            var pos = 0
            for (var j = 0; j < this.breadcrumbItems.length; j++) {
              var breadcrumbItem = this.breadcrumbItems[j]
              if (breadcrumbItem.to.params.entityId === this.entityId) {
                pos = (j + 1)
                break
              }
            }
            this.breadcrumbItems.splice(pos, (this.breadcrumbItems.length - pos))
            $.each(this.breadcrumbItems, (i, breadcrumbItem) => {
              if (i === (this.breadcrumbItems.length - 1)) {
                breadcrumbItem.active = true
              }
            })
          }
        }
        sessionStorage.setItem('myReportBreadcrumbItems', JSON.stringify(this.breadcrumbItems))
      })
    },

    calculateAndShowTimeTaken (timeTaken) {
      return this.msToTime(timeTaken)
    },

    pad (n, z) {
      z = z || 2
      return ('00' + n).slice(-z)
    },

    msToTime (timeTaken) {
      var ms = timeTaken % 1000
      timeTaken = (timeTaken - ms) / 1000
      var secs = timeTaken % 60
      timeTaken = (timeTaken - secs) / 60
      var mins = timeTaken % 60
      var hrs = (timeTaken - mins) / 60
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs)
      // return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs) + '.' + this.pad(ms, 3)
    },

    showHideScoreTimeProgressRow (values) {
      this.selectedColumns = values
      this.showHideRow()
    },

    showHideRow () {
      this.loadScoreTimeProgressGear = true
      if ($.inArray('score', this.selectedColumns) === -1) {
        $('.score-column').hide()
      } else {
        $('.score-column').show()
      }

      if ($.inArray('time', this.selectedColumns) === -1) {
        $('.time-column').hide()
      } else {
        $('.time-column').show()
      }

      if ($.inArray('progress', this.selectedColumns) === -1) {
        $('.progress-column').hide()
      } else {
        $('.progress-column').show()
      }

      if ($.inArray('resourceTime', this.selectedColumns) === -1) {
        $('.resource-time-column').hide()
      } else {
        $('.resource-time-column').show()
      }
    },

    getScoreBackgroundColor (performance) {
      var grade = 'noGrade'
      if (performance !== null) {
        if (performance >= 90) {
          grade = 'gradeA'
        } else if (performance >= 80 && performance < 90) {
          grade = 'gradeB'
        } else if (performance >= 65 && performance < 80) {
          grade = 'gradeC'
        } else if (performance >= 40 && performance < 65) {
          grade = 'gradeD'
        } else if (performance >= 0 && performance < 40) {
          grade = 'gradeE'
        }
      }
      return grade
    },
    handleRouteClick (event, summary) {
      if (this.userId) {
        event.preventDefault()
        this.entityId = summary.entityId
        this.competencyId = summary.competencyId
        this.title = summary.titleForStudent
      }
    },
    handleBreadcrumbClick (item) {
      if (!item.active) {
        this.title = item.text
        this.entityId = item.to.params.entityId
        this.competencyId = item.to.params.competencyId
      }
    }
  },

  computed: {
    ...mapState({
      'course': state => state.course.course,
      'fullClassSummary': state => state.course.fullClassSummary,
      'classSummaryWithPeer': state => state.course.classSummaryWithPeer,
      'childrenSummary': state => state.course.childrenSummary
    }),

    distributions () {
      const classSummary = { ...this.classSummaryWithPeer }
      var activities = []
      if (classSummary.uuid !== undefined) {
        const performance = classSummary.classPerformance
        const you = performance.performanceUser
        activities.push({name: '0-39', count: performance.zeroToForty, color: '#a01500', isShowShadow: (you < 40)})
        activities.push({name: '40-64', count: performance.forutyToSixtyFive, color: '#ff8000', isShowShadow: (you > 40 && you < 65)})
        activities.push({name: '65-79', count: performance.sixtyFiveToEighty, color: '#eec635', isShowShadow: (you > 65 && you < 80)})
        activities.push({name: '80-89', count: performance.eightyToNinty, color: '#929000', isShowShadow: (you > 80 && you < 90)})
        activities.push({name: '90-100', count: performance.nintyToHundred, color: '#008000', isShowShadow: (you > 90)})
      }
      return activities
    },

    scores () {
      const classSummary = { ...this.classSummaryWithPeer }
      var activities = []
      if (classSummary.uuid !== undefined) {
        const performance = classSummary.classPerformance
        activities.push({name: 'Max', count: performance.performanceMax, color: '#005391'})
        activities.push({name: 'Min', count: performance.performanceMin, color: '#005391'})
        activities.push({name: 'You', count: performance.performanceUser, color: '#f3c744'})
        activities.push({name: 'Avg', count: performance.performanceAvg, color: '#005391'})
      }
      return activities
    },

    assessmentTimes () {
      const classSummary = { ...this.classSummaryWithPeer }
      var activities = []
      if (classSummary.uuid !== undefined) {
        var max = (classSummary.assessmentMaxTimeTaken / 1000)
        var min = (classSummary.assessmentMinTimeTaken / 1000)
        var you = (classSummary.assessmentTimeTaken / 1000)
        var avg = (classSummary.assessmentAvgTimeTaken / 1000)
        if (max < 180) {
          this.assessmentTimeTakenComparisonLabel = 'Comparison in seconds'
        } else if (max > 180 && max < 10800) {
          this.assessmentTimeTakenComparisonLabel = 'Comparison in minutes'
          max = max / 60
          min = min / 60
          you = you / 60
          avg = avg / 60
        } else {
          this.assessmentTimeTakenComparisonLabel = 'Comparison in hours'
          max = max / 3600
          min = min / 3600
          you = you / 3600
          avg = avg / 3600
        }
        activities.push({name: 'Max', count: max, color: '#005391'})
        activities.push({name: 'Min', count: min, color: '#005391'})
        activities.push({name: 'You', count: you, color: '#f3c744'})
        activities.push({name: 'Avg', count: avg, color: '#005391'})
      }
      return activities
    },

    performance () {
      const classSummary = { ...this.classSummaryWithPeer }
      if (classSummary.uuid !== undefined) {
        const performance = classSummary.classPerformance
        return (performance.performanceUser !== undefined && performance.performanceUser !== null) ? performance.performanceUser.toFixed(2) : '0.00'
      }
      return '0.00'
    },

    chunkedChildrenSummary () {
      this.summaries = []
      for (var i = 0; i < this.childrenSummary.length; i++) {
        var summary = this.childrenSummary[i]
        if (!summary) {
          continue;
        }
        summary.averageScore = 'N/A'
        for (var j = 0; j < this.fullClassSummary.length; j++) {
          const classSummary = this.fullClassSummary[j]
          if (summary.entityId === classSummary.entityId) {
            const averageScore = classSummary.classPerformance.performanceAvg
            summary.averageScore = (averageScore === null || averageScore === undefined) ? 'N/A' : averageScore.toFixed(2)
            break
          }
        }
        this.summaries.push(summary)
      }
      const size = (this.summaries.length < 6) ? this.summaries.length : 6
      const chunked = _.chunk(this.summaries, size)
      return chunked
    }
  }
}
</script>

<style scoped>
.course-nav {
  background:#e1e1e1;
  min-height: 500px;
}
.coure-nav-list-item {
  background:#e1e1e1;
  border: none;
}

.course-thumbnail {
  background:#f8f9fa;
  min-height: 500px;
}

.course-information {
  margin-top:20px;
}

.course-description {
  padding-top:20px;
}

.activity-row {
  padding-top:20px;
}

.card {
  border: none!important;
}

.card-header {
  background:#f8f9fa!important;
}

.card-body {
  background:#f8f9fa!important;
}

.report-Page .heading {
    padding: 7px 7px 7px 7px;
    border-bottom: 1px solid #efefef;
    font-size: 20px;
    font-family: robotoSlab_Light;
    margin-bottom:15px;
}
.report-Page {
    padding-top:18px;
}
.report-Page .activity-graph-container {
    border: 1px solid #dbdbdb!important;
    border-radius: 0;
    min-height: 270px;
    font-family: openSans_Regular;
}

.report-Page .label {
    background: #c9e0b2;
    padding: 8px;
    color: #4d4d4d;
    font-size: 19px;
}

.report-Page .graph-area {
    height: 228px;
    display: flex;
    align-items: center;
    justify-content: center;
	padding-right:16px;
}

.graph-min-height {
    min-height:251px!important;
}

.report-Page .graph-text {
    text-align: center;
    color: #4d4d4d;
    position: relative;
    top: -42px;
}
.report-Page .dashboard-row {
    padding-left:15px;
}
.report-Page .left-space {
    padding-left:100px;
}
.report-section {
    padding-left: 15px;
}

.report-graph {
    flex: 0 0 28%!important;
    max-width: 28%!important;
	min-width:347px;
}

.competency-details-row {
    padding-left:33px;
}

.competency-details-row .title {
    width: 100%;
    float: left;
    padding: 2px 6px;
}
.competency-details-row .value {
    width: 100%;
    float: left;
    padding: 8px 8px;
}

.score-column {
    display: none;
}

.progress-column {
    display: none;
}

.time-column {
    display: none;
}

.report-section {
	/*
  min-width: 990px;
  overflow: auto;
  */
}



@media (max-width:1294px) {
	.report-graph {
		flex: 0 0 28%!important;
		max-width: 28%!important;
		min-width:317px;
	}
	.report-Page .left-space {
		padding-left: 37px;
	}
}
</style>



// WEBPACK FOOTER //
// src/app/course/components/StudentMyReport.vue